import axios from "axios";
import { PPD_ADMIN_SETTINGS_GET, PPD_ADMIN_SETTINGS, SET_ERROR, COUNTERS } from "../../types";
import ToastMessage from "../../../components/toast";

export const getAdminSettings = companyShortName => {
    return async dispatch => {
        await axios.get(`api/ppd/admin-settings/${companyShortName}`).then(res => {
            dispatch({
                type: PPD_ADMIN_SETTINGS_GET,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};

export const addUpdateAdminSettings = payload => {
    return async dispatch => {
        await axios.post('api/ppd/add-update-admin-settings', payload).then(res => {
            ToastMessage("Settings successfully updated!", "success");
            dispatch({
                type: PPD_ADMIN_SETTINGS,
                payload: res.data
            });
        }).catch(e => {
            ToastMessage(e.message, "error");
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};

export const getCounters = companyShortName => {
    return async dispatch => {
        await axios.get(`api/ppd/counters/${companyShortName}`).then(res => {
            dispatch({
                type: COUNTERS,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
}